module.exports = __webpack_public_path__ + "img/imagination.d4384a38.jpg";